// extracted by mini-css-extract-plugin
export var root = "hero-module--root--T4odi";
export var heading = "hero-module--heading--kt67M";
export var secondaryHeading = "hero-module--secondaryHeading--gBkl6";
export var buttonContainer = "hero-module--buttonContainer--6Earq";
export var content = "hero-module--content--OkjoT";
export var image = "hero-module--image--RSo53";